export const START_MEMORY_GAME_COMPLETED = "overcut/memory/startGameCompleted";
export const SET_MEMORY_GAME = "overcut/memory/setGame";
export const VALIDATE_MEMORY_PAIR_COMPLETED = "overcut/memory/validatePairCompleted";
export const SET_MEMORY_FEEDBACK = "overcut/memory/setFeedback";
export const RESET_MEMORY = "overcut/memory/reset";
